<generic-success-page
  *transloco="let t; prefix: 'comingSoonSuccess'"
  [title]="t('thankYouNote')"
  [icon]="['fas', 'check']"
  [primaryButton]="t('searchAgainBtn')"
  (primaryAction)="close()"
  [secondaryButton]="t('homepageBtn')"
  (secondaryAction)="goHome()"
  valid="true"
  image="eligibilitySuccess"
  [bigText]="true"
  (languageChange)="toggleLanguage($event)"
  [currentLanguage]="preferredLanguage$ | async"
  [showLanguageToggler]="features.isOff('yt-19374-pace-pause-prequal-updates')"
  [showLeftArrow]="false"
  [showRightArrow]="false"
>
  <p>
    {{ t('description') }}
  </p>
</generic-success-page>
